export default __webpack_public_path__ + "static/media/interview_questions.405b9c3e.jpg";